<template>
  <div id="app">
    <div v-if="$store.state.appInfo.site_state == 1">
      <div class="reveal-modal-bg" v-if="loading" style="cursor: pointer; display: flex; align-items: center; justify-content: center">
        <van-loading size="24px" vertical color="#0094ff" text-color="#0094ff">加载中...</van-loading>
      </div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" :key="$route.name" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" :key="$route.name" />
    </div>
    <div v-if="$store.state.appInfo.site_state == 0" style="box-sizing: border-box; padding: 30px; fong-size: 26px">站点维护中...</div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      daoTime: null,
      loading: false,
    };
  },
  created() {
    let that = this;
    console.log('版本代码更新时间 2022-10-21 00:32');

    var query = that.$route.query;
    if (query.pid) {
      localStorage.setItem('pid', query.pid);

      this.$router.push({ path: `/login?type=1&pid=${query.pid}` });
    }
    that.getVisitUrl();

    that.getApp();
    that.getGameList();

    if (sessionStorage.getItem('token')) {
      that.getUserInfo();
    }
  },
  methods: {
    getVisitUrl() {
      let that = this;
      var query = that.$route.query;

      that.$apiFun
        .get('/api/getVisitUrl', {})
        .then(res => {
          if (res.code == 200) {
            if (process.env.NODE_ENV == 'development') {
              //开发环境下 取消跳转
              return;
            }
            let url = query.pid ? res.data.url + 'register?pid=' + query.pid : res.data.url;
            window.open(url, '_self');
          }
        })
        .catch(res => {
          // console.log(res)
        });
    },
    // 获取游戏列表
    getGameList() {
      let that = this;
      // let bannerList = localStorage.getItem('bannerList') ? JSON.parse(localStorage.getItem('bannerList')) : [];
      // let realbetList = localStorage.getItem('realbetList') ? JSON.parse(localStorage.getItem('realbetList')) : [];
      // let jokerList = localStorage.getItem('jokerList') ? JSON.parse(localStorage.getItem('jokerList')) : [];
      // let gamingList = localStorage.getItem('gamingList') ? JSON.parse(localStorage.getItem('gamingList')) : [];
      // let sportList = localStorage.getItem('sportList') ? JSON.parse(localStorage.getItem('sportList')) : [];
      // let lotteryList = localStorage.getItem('lotteryList') ? JSON.parse(localStorage.getItem('lotteryList')) : [];
      // let conciseList = localStorage.getItem('conciseList') ? JSON.parse(localStorage.getItem('conciseList')) : [];
      // localStorage.setItem('realbetList', JSON.stringify(realbetList));
      // localStorage.setItem('jokerList', JSON.stringify(jokerList));
      // localStorage.setItem('gamingList', JSON.stringify(gamingList));
      // localStorage.setItem('sportList', JSON.stringify(sportList));
      // localStorage.setItem('lotteryList', JSON.stringify(lotteryList));
      // localStorage.setItem('conciseList', JSON.stringify(conciseList));
      // that.$store.commit('changGameList');
      // return
      that.$apiFun
        .get('/api/game/list', { category: '' })
        .then(res => {
          if (res.code == 200) {
            let list = res.data;
            let realbetList = [];
            let jokerList = [];
            let gamingList = [];
            let sportList = [];
            let lotteryList = [];
            let conciseList = [];
            list.forEach(el => {
              if (el.category_id == 'realbet' && el.app_state == 1) {
                realbetList.push(el);
              }
              if (el.category_id == 'joker' && el.app_state == 1) {
                jokerList.push(el);
              }
              if (el.category_id == 'gaming' && el.app_state == 1) {
                gamingList.push(el);
              }
              if (el.category_id == 'sport' && el.app_state == 1) {
                sportList.push(el);
              }
              if (el.category_id == 'lottery' && el.app_state == 1) {
                lotteryList.push(el);
              }
              if (el.category_id == 'concise' && el.app_state == 1) {
                conciseList.push(el);
              }
            });
            localStorage.setItem('realbetList', JSON.stringify(realbetList));
            localStorage.setItem('jokerList', JSON.stringify(jokerList));
            localStorage.setItem('gamingList', JSON.stringify(gamingList));
            localStorage.setItem('sportList', JSON.stringify(sportList));
            localStorage.setItem('lotteryList', JSON.stringify(lotteryList));
            localStorage.setItem('conciseList', JSON.stringify(conciseList));
            that.$store.commit('changGameList');
          }
        })
        .catch(() => {
          let that = this;
          let bannerList = localStorage.getItem('bannerList') ? JSON.parse(localStorage.getItem('bannerList')) : [];
          let realbetList = localStorage.getItem('realbetList') ? JSON.parse(localStorage.getItem('realbetList')) : [];
          let jokerList = localStorage.getItem('jokerList') ? JSON.parse(localStorage.getItem('jokerList')) : [];
          let gamingList = localStorage.getItem('gamingList') ? JSON.parse(localStorage.getItem('gamingList')) : [];
          let sportList = localStorage.getItem('sportList') ? JSON.parse(localStorage.getItem('sportList')) : [];
          let lotteryList = localStorage.getItem('lotteryList') ? JSON.parse(localStorage.getItem('lotteryList')) : [];
          let conciseList = localStorage.getItem('conciseList') ? JSON.parse(localStorage.getItem('conciseList')) : [];
          localStorage.setItem('realbetList', JSON.stringify(realbetList));
          localStorage.setItem('jokerList', JSON.stringify(jokerList));
          localStorage.setItem('gamingList', JSON.stringify(gamingList));
          localStorage.setItem('sportList', JSON.stringify(sportList));
          localStorage.setItem('lotteryList', JSON.stringify(lotteryList));
          localStorage.setItem('conciseList', JSON.stringify(conciseList));
          that.$store.commit('changGameList');
        });
    },
    // 获取app
    getApp() {
      let that = this;
      that.$apiFun.post('/api/app', {}).then(res => {
        if (res.code == 200) {
          localStorage.setItem('appInfo', JSON.stringify(res.data));
          that.$store.commit('changappInfo');
          document.getElementsByTagName('title')[0].innerText = that.$store.state.appInfo.title;
        }
      });
    },
    //下载文件
    downloadUrl(url) {
      let that = this;
      this.showLoading();
      console.log(url);
      const iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.style.display = 'none'; // 防止影响页面
      iframe.style.height = 0; // 防止影响页面
      document.body.appendChild(iframe); // 必写，iframe挂在到dom树上才会发请求
      // 定时删除节点
      setTimeout(() => {
        that.hideLoading();

        document.body.removeChild(iframe);
      }, 2000);
    },
    // 退出登录
    outLogin() {
      let that = this;

      that.$dialog
        .confirm({
          title: '提示',
          message: '您确定要退出登录吗?',
        })
        .then(() => {
          that.showLoading();

          that.$apiFun
            .post('/api/logoff', {})
            .then(res => {
              that.hideLoading();
              that.clearUser();
              that.$router.push({ path: '/login' });
            })
            .catch(() => {
              that.hideLoading();
              that.clearUser();

              that.$router.push({ path: '/login' });
            });
        })
        .catch(() => {});
    },
    // 打开游戏
    openGamePage(name, type, code) {
      let that = this;
      let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
      if (!token) {
        that.showTost(0, '请登录！');
        return;
      }
      that.showTost(1, '跳转中...');

      that.showLoading();
      if (name == 'avia' || name == 'yb') {
        that.hideLoading();
        that.goNav(`/gamePage?name=${name}&type=${type}&code=${code}`);
        return;
      }
      that.$apiFun
        .post('/api/getGameUrl', { plat_name: name, game_type: type || 0, game_code: code, is_mobile_url: 1 })
        .then(res => {
          if (res.code != 200) {
            that.hideLoading();
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            window.location.href = res.data.url;
            setTimeout(() => {
              that.hideLoading();
            }, 1000);
          }
        })
        .catch(res => {
          let that = this;
          that.showTost(0, '网络连接超时，请重试!');
          that.hideLoading();
        });
    },
    // openGamePage(name, type, code) {
    //   let that = this;
    //   let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
    //   if (!token) {
    //     that.showTost(0, '请登录！');

    //     return;
    //   }
    //   that.goNav(`/gamePage?name=${name}&type=${type}&code=${code}`);
    // },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();
      document.execCommand('copy');
      this.showTost(1, '复制成功！');
    },
    goNav(url) {
      let that = this;
      if (url == '/hongbao' || url == '/transfer') {
        if (!that.$store.state.token) {
          that.$dialog
            .confirm({
              message: '精彩内容等你来体验，快来登录吧！',
            })
            .then(() => {
              this.$router.push({ path: '/login' });
            });

          return;
        }
        if (url == '/hongbao' && that.$store.state.appInfo.redpacket_switch == 0) {
          that.showTost(0, '红包已关闭');
          return;
        }
      }
      if (url == this.$route.fullPath) {
        that.showTost(0, '已在当前页面！');
        return;
      }

      this.$router.push({ path: url });
    },
    closeDaoTime() {
      let that = this;
      if (that.daoTime != null) {
        clearInterval(that.daoTime);
      }
      that.daoTime = null;
    },
    // 不刷新页面更新用户余额
    getBalance() {
      let that = this;
      that.$apiFun
        .post('/api/balance', {})
        .then(res => {
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
            userInfo.gameblance = res.data.gameblance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
           if (res.code == 401) {
            let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
            if (token) {
              that.$dialog
                .alert({
                  title: '认证失败',
                  message: '您的账号登陆过期，请重新登陆',
                })
                .then(() => {
                  that.$router.push({ path: '/login' });
                });
            }
            that.clearUser();
          }
        })
        .catch(res => {});
    },
    clearUser() {
      let that = this;
      that.closeDaoTime();
      localStorage.clear();
      sessionStorage.clear();
      that.$store.commit('changUserInfo');
      that.$store.commit('changToken');
    },
    openDaoTime() {
      let that = this;
      if (!that.daoTime) {
        that.daoTime = setInterval(() => {
          that.getBalance();
        }, 4300);
      }
    },
    // 不刷新页面跟新用户信息
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          let userInfo = res.data;
          if (userInfo.isblack == 1) {
            //黑名单

            that.clearUser();
            that.showTost(0, '您已被设为黑名单，暂不能登录，请联系管理员！');

            return;
          }
          if (userInfo.status == 0) {
            //用户被禁用
            that.clearUser();
            that.showTost(0, '该用户已被禁用，请联系管理员！');

            return;
          }
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length); //04
          userInfo.vip = vip;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.userInfo = userInfo;
          that.$store.commit('changUserInfo');
          that.openDaoTime();
        }
      });
    },
    // 刷新页面更新信息
    getUserInfoShowLoding() {
      let that = this;
      that.showLoading();
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          let userInfo = res.data;
          if (userInfo.isblack == 1) {
            //黑名单
            that.hideLoading();

            that.clearUser();
            that.showTost(0, '您已被设为黑名单，暂不能登录，请联系管理员！');

            return;
          }
          if (userInfo.status == 0) {
            //用户被禁用
            that.hideLoading();

            that.clearUser();
            that.showTost(0, '该用户已被禁用，请联系管理员！');

            return;
          }
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length); //04
          userInfo.vip = vip;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.userInfo = userInfo;
          that.$store.commit('changUserInfo');
          that.hideLoading();
          that.openDaoTime();
        }
      });
    },
    // 获取代理
    getAgentLoginUrl() {
      let that = this;
      that.$parent.goNav(`/gamePage?dailiD=1`);
    },
    openKefu() {
      let that = this;
      that.goNav('/kefu');
      // that.goNav(`/gamePage?dailiD=2`);
    },
    showTost(type, title) {
      let str = type ? 'success' : 'danger';
      this.$notify({ type: str, message: title });
    },
    showLoading() {
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
    },
  },
  mounted() {},
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
};
</script>

<style>
/* @import '../static/css/registermember.css';
 @import '../static/css/registermember.css';
 @import '../static/css/registermember.css';
 @import '../static/css/registermember.css'; */

.meLoading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
}
.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #069b71;
}

.step .van-tab--active {
  color: #fff;
  background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUwIiBoZWlnaHQ9IjM2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0wIDB2MzZoMjQwLjgzN0wyNTAgMThsLTkuMTYzLTE4eiIgZmlsbD0iIzA2OUI3MSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+) no-repeat 100% / cover;
}

.step .van-tabs--line .van-tabs__wrap {
  height: 27px;
}
.metransRecord .van-tabs__nav--card .van-tab.van-tab--active {
  color: #fff;
  background-color: #069b71;
  border-radius: 22px;
}
.metransRecord .van-tabs__nav--card {
  border: none;
}
.metransRecord .van-tabs__nav--card .van-tab {
  border: none;
}
.metransRecord .van-tabs__nav--card .van-tab {
  color: #000;
}

body {
  padding: 0 !important;
}
.inputsw {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 999;
  cursor: pointer;
}
.bancgs {
  position: fixed;
  top: 10px;
  left: 10px;
  width: 30px;
  opacity: 0.8;
  z-index: 200;
}
</style>



// WEBPACK FOOTER //
// src/App.vue